module.exports = __webpack_public_path__ + "img/bg_main0204.62ff78a6.png";